const header = document.querySelector('.header');
let ticking = false;
const isMobile = window.innerWidth <= 768;

document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      if (window.scrollY > 1) {
        header.classList.add('active', 'small');
      } else {
        header.classList.remove('active', 'small');
      }
      ticking = false;
    });
    ticking = true;
  }
});

function initLogoLottie() {
  const logoContainer = document.querySelector('.header__logo-lottie');
  if (!logoContainer) return;

  if (typeof lottie === 'undefined') {
    window.addEventListener('lottie:loaded', initLogoLottie, { once: true });
    setTimeout(initLogoLottie, 100);
    return;
  }

  if (logoContainer.dataset.lottieInit === '1') return;
  logoContainer.dataset.lottieInit = '1';

  lottie.loadAnimation({
    container: logoContainer,
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path: logoContainer.getAttribute('data-src')
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const burger = document.querySelector('.header__burger');
  const menu = document.querySelector('.header__nav');
  const body = document.body;

  burger.addEventListener('click', () => {
    burger.classList.toggle('active');
    menu.classList.toggle('active');
    body.classList.toggle('menu-open');
  });

  const desktopBtn = document.querySelector('.header__btn.header__btn--desktop');
  const headerMenu = document.querySelector('.header__menu');
  const email = document.querySelector('.header__email');

  if (headerMenu && desktopBtn) {
    headerMenu.classList.add('animated');
    desktopBtn.classList.add('animated');
    if (email) email.classList.add('animated');
  }

  const bottom = document.querySelector('.scroll__bottom');
  const inner = document.querySelector('.scroll__inner');

  if (bottom) {
    bottom.classList.add('visible');
    if (inner) inner.classList.add('visible');
  }

  initLogoLottie();
});


const subParent = document.querySelector('.menu-item-has-children');
const subItem = document.querySelector('.menu-item-has-children > a');
const submenu = document.querySelector('.menu-item-has-children ul');

if (subItem) {
  subItem.addEventListener('click', e => {

    if (!isMobile) return;

    const isOpen = subParent.classList.contains('active');

    // ПЕРШИЙ КЛІК — відкриваємо меню
    if (!isOpen) {
      e.preventDefault(); // блокуємо перехід
      submenu.style.height = submenu.scrollHeight + 'px';
      subParent.classList.add('active');
    }
    // ДРУГИЙ КЛІК — нічого не блокуємо, лінк працює
  });
}

const emails = document.querySelectorAll('.header__email');
if (emails) {
  emails.length && emails.forEach(email => {
    const copied = email.querySelector('.header__copied');

    if (email && copied) {
      email.addEventListener('click', (e) => {
        e.preventDefault();

        const href = email.getAttribute('href');
        if (!href) return;

        const textToCopy = href.replace('mailto:', '');
        console.log(textToCopy);

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(textToCopy).catch(err => {
            console.error('Clipboard error:', err);
          });
        } else {
          const tempInput = document.createElement('input');
          tempInput.value = textToCopy;
          document.body.appendChild(tempInput);
          tempInput.select();
          document.execCommand('copy');
          document.body.removeChild(tempInput);
        }

        copied.animate(
          [
            { opacity: 0, transform: 'translateY(0)' },
            { opacity: 1, transform: 'translateY(-26px)', offset: 0.15 },
            { opacity: 1, transform: 'translateY(-26px)', offset: 0.85 },
            { opacity: 0, transform: 'translateY(-40px)' }
          ],
          {
            duration: 800,
            easing: 'cubic-bezier(0.70, 0.00, 0.30, 1.00)',
            fill: 'forwards'
          }
        );
      });
    }

  })

}

document.addEventListener('DOMContentLoaded', () => {
    const select = document.querySelector('.lang-select');
    const button = select.querySelector('.lang-select__button');
    const dropdown = select.querySelector('.lang-select__dropdown');

    const wpmlSwitcher = document.querySelector('.wpml-ls-statics-footer');

    const links = wpmlSwitcher.querySelectorAll('.wpml-ls-link');

    dropdown.innerHTML = '';

    links.forEach((link) => {
        const clonedLink = link.cloneNode(true);

        clonedLink.classList.add('lang-select__link');

        dropdown.appendChild(clonedLink);
    });

    button.addEventListener('click', (e) => {
        e.stopPropagation();
        select.classList.toggle('open');
    });

    document.addEventListener('click', (e) => {
        if (!select.contains(e.target)) {
            select.classList.remove('open');
        }
    });
});
